import { IconButton, Tooltip, useTheme } from '@mui/material';
import { Refresh } from 'iconsax-react';
import type { ReactElement } from 'react';

type ClearButtonProps = {
  onClear: () => void;
};

export const ClearButton = ({ onClear }: ClearButtonProps): ReactElement => {
  const theme = useTheme();
  return (
    <Tooltip title='Clear Filters'>
      <IconButton onClick={onClear}>
        <Refresh variant='TwoTone' color={theme.palette.SlabIndigo['700']} />
      </IconButton>
    </Tooltip>
  );
};
